module.exports = __webpack_public_path__ + "static/coach-hire-services-sporting-events-267f0caae7a0fedeb053d07d4f6e4710.jpg";